export const socialMediaColors = {
  facebook: "#6C63F0",
  youtube: "#FB466C",
  instagram: "#ED589D",
  twitter: "#3AACFF",
  tiktok: "#B750BE",
};

export const feetJSON = [
  { label: "3'", value: 3 },
  { label: "4'", value: 4 },
  { label: "5'", value: 5 },
  { label: "6'", value: 6 },
  { label: "7'", value: 7 },
]
export const inchesJSON = [
  { label: '0"', value: 0 },
  { label: '1"', value: 1 },
  { label: '2"', value: 2 },
  { label: '3"', value: 3 },
  { label: '4"', value: 4 },
  { label: '5"', value: 5 },
  { label: '6"', value: 6 },
  { label: '7"', value: 7 },
  { label: '8"', value: 8 },
  { label: '9"', value: 9 },
  { label: '10"', value: 10 },
  { label: '11"', value: 11 },
  { label: '12"', value: 12 },
]
export const languageJSON = [
  { value: 'english', label: 'English' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'kannada', label: 'Kannada' },
  { value: 'malayalam', label: 'Malayalam' },
  { value: 'tamil', label: 'Tamil' },
  { value: 'telugu', label: 'Telugu' },
  { value: 'marathi', label: 'Marathi' },
  { value: 'punjabi', label: 'Punjabi' },
  { value: 'bengali', label: 'Bengali' },
  { value: 'oriya', label: 'Oriya' },
  { value: 'assamese', label: 'Assamese' },
]

export const hairColorJSON = [
  { value: "black", label: "Black" },
  { value: "brown", label: "Brown" },
  { value: "blond", label: "Blond" },
  { value: "white_gray", label: "White/Gray" },
  { value: "red", label: "Red" },
]

export const hairLengthJSON = [
  { value: 'ear_length', label: 'Ear length' },
  { value: 'chin_length', label: 'Chin length' },
  { value: 'shoulder_length', label: 'Shoulder length' },
  { value: 'armpit_length', label: 'Armpit length' },
  { value: 'mid_back', label: 'Mid back length' },
  { value: 'waist_length', label: 'Waist length' },
  { value: 'knee_length', label: 'Knee length' },
]

export const tattoosJSON = [
  { value: "ankle", label: "Ankle" },
  { value: "wrist", label: "Wrist" },
  { value: "neck", label: "Neck" },
]

export const piercingsJSON = [
  { value: "facial", label: "Facial" },
  { value: "lip", label: "Lip" },
  { value: "nose", label: "Nose" },
]

export const countJSON = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10+", label: "10+" },
]